import Utils from 'services/utils';
import Config from 'services/config/local';
import User from './user.class';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./user.json'); // eslint-disable-line global-require
    require('./users.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    const data = response.data;

    if ('users' in data) {
        data.users = data.users.map(user => new User(user));
    }

    return data;
}

/**
 * UsersApi class.
 */
export default class UsersApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.users;
    }

    /**
     * Get Users
     * @returns {promise}
     */
    getList() {
        return this.$http.get(this.config.listUrl).then(responseDataExtractor);
    }

    /**
     * Search Users by given query
     * @param {string} query - Pattern for user search
     * @param {Object} [metadata={}] - optional, set limit and ofset
     * @returns {promise}
     */
    search(query, metadata = {}) {
        return this.$http.get(
            this.config.searchUrl,
            {
                params: {
                    query: `${query}*`,
                    ...metadata
                }
            })
            .then(responseDataExtractor);
    }

    /**
     * Get User by given id
     * @param {number} userId - User id
     * @returns {promise}
     */
    getUser(userId) {
        const url = Utils.formatString({ userId }, this.config.getUrl);

        return this.$http.get(url).then(responseDataExtractor);
    }

    /**
     * Delete user by given id
     * @param {number} userId - User id
     * @returns {promise}
     */
    deleteUser(userId) {
        const url = Utils.formatString({ userId }, this.config.deleteUrl);

        return this.$http.delete(url).then(responseDataExtractor);
    }

    /**
     * Update User
     * @param {Object} user - User object
     * @returns {promise}
     */
    updateUser(user) {
        return this.$http.put(this.config.updateUrl, { ...user }).then(responseDataExtractor);
    }

    /**
     * Create User
     * @param {Object} user - User object
     * @returns {promise}
     */
    createUser(user) {
        return this.$http.post(this.config.createUrl, { ...user }).then(responseDataExtractor);
    }

    /**
     * Reset User password by given id
     * @param {number} userId - User id
     * @returns {promise}
     */
    resetPassword(userId) {
        const url = Utils.formatString({ userId }, this.config.resetPasswordUrl);

        return this.$http.post(url).then(responseDataExtractor);
    }

    /**
     * Upload User image
     * @param {number} userId - User id
     * @param {string} image - Image content
     * @returns {promise}
     */
    uploadProfileImage(userId, image) {
        const url = Utils.formatString({ userId }, this.config.uploadProfileImageUrl);

        return this.$http.post(url, { 'user_id': userId, image }).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/api/users/users.service.js